module.exports = __webpack_public_path__ + "img/buckwheat.be5030ca.webp";